

import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { NotificationService } from 'src/app/Service/notification.service';
import { DrawingInactiveInputModel, DrawingInactiveOutputModel, IDeleteDocumentInputModel, IDeleteDocumentOutputModel } from 'src/app/ViewModel/DeletedocumentModel';
import { CommonService } from 'src/app/Service/Common.service';
import { DeleteDocumentService } from 'src/app/Service/deletedocument/deletedocument.service';
import { ScheduleWorkflowhistoryComponent } from '../../engineering-schedule/schedule-workflowhistory/schedule-workflowhistory.component';
import { State } from '@progress/kendo-data-query';
import { DeleteDocumentResponseComponent } from '../dialogs/Delete-Document-Response/Delete-Document-Response.components';
import { DrawingInactiveResponseComponent } from "../Drawing-Inactive-Response/Drawing-Inactive-Response.components";
import { Subscription } from "rxjs";
import { MapRoleFeatureService } from "src/app/Service/map-role-feature/map-role-feature.service";
import { BusinessGroupModel } from "src/app/ViewModel/BusinessGroupModel";

@Component({
  selector: 'app-delete-documents',
  templateUrl: './delete-document.components.html',
  styleUrls: ['./delete-document.components.css']
})
export class DeleteDocumentComponents implements OnInit, OnDestroy {
  enableFilter = false;
  enableFullscreen = false;
  projectId: number | undefined;
  groupId: number | null | undefined;
  public state: State = {
    skip: 0,
    take: 5,

    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: []
    }
  };
  RevisionType: string = "1";
  public pageSize = [15, 30, 50, 100, {
    text: 'All',
    value: 'all'
  }];

  /**Members list against the business group */
  public DocumentList: IDeleteDocumentOutputModel[] = [];

  selectedOption: string = 'Active';
  CanDeleteDocumentPermanently: boolean = false;
  CanRecoverDocument: boolean = false;
  CanDeleteDocument: boolean = false;
  subscriptions: Subscription[] = [];
  /** Business Group List */
  private businessGroupList: ReadonlyArray<BusinessGroupModel> = [];

  constructor(private _dialog: MatDialog, private _notificationService: NotificationService, public commonService: CommonService, public _DeleteDocumentService: DeleteDocumentService, private _ResdialogRef: MatDialog, private mapRoleFeatureService: MapRoleFeatureService) {

  }

  ngOnInit() {
    this.projectId = this.commonService.getProjectId();
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.getDocumentList();
    this.enableMemberRoleFeatures();
    this.getBusinessGroups(this.commonService.getProjectId());
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }

  enableMemberRoleFeatures() {
    let _getProjectMemberFeatures = this.commonService.getProjectMemberFeatures(this.projectId, this.commonService.getLoggedInUserId(), this.groupId).subscribe((res: any[]) => {
      this.CanDeleteDocumentPermanently = res.some(data => data.feature_Desc == 'Delete Document Permanently');
      this.CanRecoverDocument = res.some(data => data.feature_Desc == 'Recover Document');
      this.CanDeleteDocument = res.some(data => data.feature_Desc == 'Delete');
    });
    this.subscriptions.push(_getProjectMemberFeatures);
  }

  changeButtonToggle(event: any) {
    this.selectedOption = event.value;
    this.RevisionType = (event.value == 'Active') ? '1' : '2';
    this.getDocumentList();
  }

  /**
* Get Business Group list
* @param _projectId 
*/
  getBusinessGroups(_projectId: number) {
    this.mapRoleFeatureService.getBusinessGroups(_projectId).subscribe((data: any) => {
      this.businessGroupList = data.filter((eachData: any) => eachData.is_Active);
    });
  }

  /**
   * Business group dropdown event handling
   * @param event 
   */
  changeBusinessGroup(event: { value: string | number | null; }) {
    if (event.value !== '-2') {
      this.groupId = Number(event.value);
      this.enableMemberRoleFeatures();
      this.getDocumentList();
    } else {
      this.groupId = null;
    }
  }

  getDocumentList() {
    this.DocumentList = [];
    let obj: any | IDeleteDocumentInputModel = {
      projectId: this.projectId,
      groupId: (!!this.groupId ? this.groupId : null),
      doc_Id: null,
      revision_type: this.RevisionType,
      UserId: this.commonService.getLoggedInUserId()
    };
    let subscription = this._DeleteDocumentService.GetDeleteDocumentlist(obj).subscribe((data: IDeleteDocumentOutputModel[]) => {
      this.DocumentList = data.filter(x => x.is_Active == (this.selectedOption == 'Active'));
    });

    this.subscriptions.push(subscription);
  }

  public onSelectionChange(event: any | Event): void {
    if (event['selectedRows'].length > 0) {
      event['selectedRows'].forEach((element: { dataItem: { is_select: boolean; }; }) => {
        element.dataItem.is_select = true;
      });
    }
    if (event['deselectedRows'].length > 0) {
      event['deselectedRows'].forEach((element: { dataItem: { is_select: boolean; }; }) => {
        element.dataItem.is_select = false;
      });
    }
  }
  public dataStateChange(state: any): void {
    this.DocumentList.map(x => x.is_select = false);
  }

  handleHeaderCheckboxEvent(event: any) {
    this.DocumentList.map(x => x.is_select = event.checked)
  }

  /**
* Toggle filter
*/
  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  /**
     * Full screen
     */
  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }

  public clearFilters() {
    this.state.filter = {
      logic: 'and',
      filters: []
    };
  }

  public onClick_WorkflowHistory(dataItem: IDeleteDocumentOutputModel) {
    let obj = {
      doc_Id: dataItem.doc_Id,
      documentId: dataItem.doc_Id,
      doc_Title: dataItem.document_title,
      doc_No: dataItem.document_no,
      documentTitle: dataItem.document_title,
      documentNumber: dataItem.document_no,
      FromDeleteDocument: (this.selectedOption == "Active" && this.CanDeleteDocumentPermanently ? true : false)
    };

    let dialogRef = this._dialog.open(ScheduleWorkflowhistoryComponent, {
      panelClass: 'mat-dialog-primary',
      data: obj
    });

    dialogRef.afterClosed().subscribe((data) => {
      this.getDocumentList();
      this.clearFilters();
    });
  }

  DrawingDeletionResponse(res: any[]) {
    let dialogRef = this._ResdialogRef.open(DeleteDocumentResponseComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '95%',
      minWidth: '95vw',
      data: res
    });
    let subscription = dialogRef.afterClosed().subscribe((data) => {
      this.getDocumentList();
      this.clearFilters();
    });

    this.subscriptions.push(subscription);
  }

  DeleteDocument(Document: IDeleteDocumentInputModel) {
    let selectedDocIds: number[] = [];
    let IsTransmittalAvailable: boolean = false;
    let IsComminicationAvailable: boolean = false;

    if (!!Document) {
      selectedDocIds.push(+Document.doc_Id);
      IsTransmittalAvailable = this.DocumentList.some(x => x.doc_Id == +Document.doc_Id && x.isTransmittalAvailable);
      IsComminicationAvailable = this.DocumentList.some(x => x.doc_Id == +Document.doc_Id && x.isComminicationAvailable);
    }
    else {
      if (this.selectedOption == "Active") {
        selectedDocIds = this.DocumentList.filter(x => x.is_select && x.revSlNo > 1).map(x => x.doc_Id);
        IsTransmittalAvailable = this.DocumentList.some(x => x.is_select && x.revSlNo > 1 && x.isTransmittalAvailable);
        IsComminicationAvailable = this.DocumentList.some(x => x.is_select && x.revSlNo > 1 && x.isComminicationAvailable);
      }
      else {
        selectedDocIds = this.DocumentList.filter(x => x.is_select).map(x => x.doc_Id);
        IsTransmittalAvailable = this.DocumentList.some(x => x.is_select && x.isTransmittalAvailable);
        IsComminicationAvailable = this.DocumentList.some(x => x.is_select && x.isComminicationAvailable);
      }
    }

    if (selectedDocIds && selectedDocIds.length > 0) {
      this._notificationService.showPopup((this.selectedOption == "Active" ? (IsTransmittalAvailable || IsComminicationAvailable ? 'Selected Revision contains Transmittal/Communication, Are you sure you want to Delete the <b>Revision</b> from the System?' : 'Are you sure you want to Delete the <b>Revision</b> from the System?') : (IsTransmittalAvailable || IsComminicationAvailable ? 'Selected Documents contains Transmittal/Communication, Are you sure you want to Permanently Delete the <b>Documents</b> from the System?' : 'Are you sure you want to Permanently Delete the <b>Documents</b> from the System?')), 'Confirm').then(data => {
        if (data == 'yes') {
          let obj: any | IDeleteDocumentInputModel = {
            groupId: 0,
            projectId: this.projectId,
            doc_Id: selectedDocIds.toString(),
            revision_type: this.RevisionType,
            UserId: this.commonService.getLoggedInUserId()
          };
          let subscription = this._DeleteDocumentService.DeleteDocumentList(obj).subscribe((res: any[]) => {
            if (res) {
              this.DrawingDeletionResponse(res);
            }
          });
          this.subscriptions.push(subscription);
        }
      });
    }
    else {
      this._notificationService.showToast("Kindly select Documents", "Warning");
    }
  }

  DrawingInactiveResponse(res: any[]) {
    let dialogRef = this._dialog.open(DrawingInactiveResponseComponent, {
      panelClass: 'mat-dialog-secondary',
      width: '95%',
      minWidth: '95vw',
      data: res
    });

    let subscription = dialogRef.afterClosed().subscribe((data) => {
      this.getDocumentList();
    });
    this.subscriptions.push(subscription);
  }

  UpdateAllDocuments(Document?: DrawingInactiveOutputModel) {
    let selectedDocIds: number[] = [];

    if (!!Document)
      selectedDocIds.push(Document.doc_Id);
    else
      selectedDocIds = this.DocumentList.filter(x => x.is_select).map(x => x.doc_Id);

    if (selectedDocIds && selectedDocIds.length > 0) {
      let obj: DrawingInactiveInputModel = {
        groupId: this.commonService.getLoggedInUserGroupId(),
        projectId: this.projectId,
        doc_Id: selectedDocIds.toString(),
        status: (this.selectedOption == "Active" ? false : true),
        doc_no: null,
        doc_title: null,
        userid: this.commonService.getLoggedInUserId()
      };
      this._notificationService.showPopup('Are you sure you want to <b>' + (this.selectedOption == "Active" ? 'Inactivate' : 'Activate') + '</b> the selected Documents?', 'Confirm').then(data => {
        if (data == 'yes') {
          let subscription = this._DeleteDocumentService.UpdateDrawingStatus(obj).subscribe((res: DrawingInactiveOutputModel[]) => {
            this.DrawingInactiveResponse(res)
          });
          this.subscriptions.push(subscription);
        }
      });
    }
    else {
      this._notificationService.showToast("Kindly select Documents", "Warning");
    }
  }
}
